import { render, staticRenderFns } from "./CostAssign.vue?vue&type=template&id=6eeed996&scoped=true&"
import script from "./CostAssign.vue?vue&type=script&lang=js&"
export * from "./CostAssign.vue?vue&type=script&lang=js&"
import style0 from "./CostAssign.vue?vue&type=style&index=0&id=6eeed996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeed996",
  null
  
)

export default component.exports